import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import SEO from '@/components/SEO';
import CrmLayout from '@/crm/CrmLayout';
import Dashboard from '@/crm/pages/Dashboard';
import StatsAvancees from '@/crm/pages/StatsAvancees';
import MesDossiers from '@/crm/pages/MesDossiers';
import Taches from '@/crm/pages/Taches';
import Prestations from '@/crm/pages/Prestations';
import NouvelleDemande from '@/crm/pages/NouvelleDemande';
import ArtistesCalcul from '@/crm/pages/ArtistesCalcul';
import Artistes from '@/crm/pages/Artistes';
import Propositions from '@/crm/pages/Propositions';
import Contrats from '@/crm/pages/Contrats';
import ContratsArtistes from '@/crm/pages/ContratsArtistes';
import PropositionsContrats from '@/crm/pages/PropositionsContrats';
import NouveauContrat from '@/crm/pages/NouveauContrat';
import Relances from '@/crm/pages/Relances';
import RelancesFactures from '@/crm/pages/RelancesFactures';
import Agenda from '@/crm/pages/Agenda';
import Clients from '@/crm/pages/Clients';
import SuiviArtistes from '@/crm/pages/SuiviArtistes';
import SuiviClients from '@/crm/pages/SuiviClients';
import SuiviDomaines from '@/crm/pages/SuiviDomaines';
import AnnuaireAnalytique from '@/crm/pages/AnnuaireAnalytique';
import Parametres from '@/crm/pages/Parametres';
import Facturation from '@/crm/pages/Facturation';
import SuiviReglement from '@/crm/pages/SuiviReglement';
// Devis page supprimée : fusionnée dans Propositions
import Journal from '@/crm/pages/Journal';
import Corbeille from '@/crm/pages/Corbeille';
import Archives from '@/crm/pages/Archives';
import Doublons from '@/crm/pages/Doublons';
import Utilisateurs from '@/crm/pages/Utilisateurs';
import ExportComptable from '@/crm/pages/ExportComptable';
import RolesPermissions from '@/crm/pages/RolesPermissions';
import MonCompte from '@/crm/pages/MonCompte';
import Notifications from '@/crm/pages/Notifications';
import { AuthProvider, useAuth } from '@/crm/auth/AuthContext';
import { PermissionsProvider } from '@/crm/auth/PermissionsContext';
import { StructureProvider } from '@/crm/structureContext';
import { NotificationsProvider } from '@/crm/notifications/NotificationsContext';
import AuthPage from '@/crm/auth/AuthPage';
import Unauthorized from '@/crm/auth/Unauthorized';
import { ConfirmProvider } from '@/crm/components/ConfirmDialog';
import CrmTitle from '@/crm/CrmTitle';

function CrmGate() {
  const { user, loading, isAuthorized, signOut } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-400 text-sm">
        Chargement…
      </div>
    );
  }

  if (!user) return <AuthPage />;
  if (!isAuthorized) return <Unauthorized />;

  return (
    <PermissionsProvider>
    <StructureProvider>
    <NotificationsProvider>
    <ConfirmProvider>
    <CrmLayout onLogout={signOut}>
      <CrmTitle />
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="stats-avancees" element={<StatsAvancees />} />
        <Route path="mes-dossiers" element={<MesDossiers />} />
        <Route path="taches" element={<Taches />} />
        <Route path="prestations" element={<Prestations />} />
        <Route path="nouvelle-demande" element={<NouvelleDemande />} />
        <Route path="artistes" element={<Artistes />} />
        <Route path="artistes-calcul" element={<ArtistesCalcul />} />
        <Route path="propositions-contrats" element={<PropositionsContrats />} />
        <Route path="propositions" element={<Navigate to="../propositions-contrats?tab=propositions" replace />} />
        <Route path="contrats" element={<Navigate to={`../propositions-contrats?tab=contrats${location.search ? location.search.replace(/^\?/, '&') : ''}`} replace />} />
        <Route path="contrats/nouveau" element={<NouveauContrat />} />
        <Route path="contrats-artistes" element={<ContratsArtistes />} />
        {/* Route /devis supprimée : fusionnée avec /propositions */}
        <Route path="facturation" element={<Facturation />} />
        <Route path="suivi-reglement" element={<SuiviReglement />} />
        <Route path="export-comptable" element={<ExportComptable />} />
        <Route path="relances" element={<Relances />} />
        <Route path="relances-factures" element={<RelancesFactures />} />
        <Route path="agenda" element={<Agenda />} />
        <Route path="clients" element={<Clients />} />
        <Route path="annuaire-analytique" element={<AnnuaireAnalytique />} />
        <Route path="suivi-clients" element={<Navigate to="../annuaire-analytique?tab=clients" replace />} />
        <Route path="suivi-artistes" element={<Navigate to="../annuaire-analytique?tab=artistes" replace />} />
        <Route path="suivi-domaines" element={<Navigate to="../stats-avancees?tab=domaines" replace />} />
        <Route path="journal" element={<Journal />} />
        <Route path="corbeille" element={<Corbeille />} />
        <Route path="archives" element={<Archives />} />
        <Route path="doublons" element={<Doublons />} />
        <Route path="parametres" element={<Parametres />} />
        <Route path="utilisateurs" element={<Utilisateurs />} />
        <Route path="roles-permissions" element={<RolesPermissions />} />
        <Route path="mon-compte" element={<MonCompte />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="*" element={<Navigate to="" replace />} />
      </Routes>
    </CrmLayout>
    </ConfirmProvider>
    </NotificationsProvider>
    </StructureProvider>
    </PermissionsProvider>
  );
}

const CrmPro = () => (
  <>
    <SEO title="CRM Pro — Cygnature" description="Espace privé." noindex />
    <AuthProvider>
      <CrmGate />
    </AuthProvider>
  </>
);

export default CrmPro;
